import { create } from 'zustand';
import { WfProduct, WfProductDetails } from '../models/WfProduct';
import { persist, createJSONStorage } from 'zustand/middleware';
import { sharedStorage } from 'src/common/storage/storage';

interface WfProductStore {
  products: WfProduct[];
  productDetails: WfProductDetails | null;
  selectedProduct: WfProduct | null;
  setProducts: (products: WfProduct[]) => void;
  setProductDetails: (products: WfProductDetails | null) => void;
  setSelectedProduct: (selectedProduct: WfProduct | null) => void;
  clearProducts: () => void;
}

export const useWfProductStore = create<WfProductStore>()(
  persist<WfProductStore>(
    (set) => ({
      products: [],
      productDetails: null,
      selectedProduct: null,
      setProducts: (products: WfProduct[]) => set({ products }),
      setProductDetails: (productDetails: WfProductDetails | null) => set({ productDetails }),
      // Clear stale productDetails (and its photo IDs) so a new SE never briefly inherits the previous SE's data.
      setSelectedProduct: (selectedProduct: WfProduct | null) =>
        set({ selectedProduct, productDetails: null }),
      clearProducts: () => set({ products: [] }),
    }),
    {
      name: 'wf-product',
      storage: createJSONStorage(() => sharedStorage),
      partialize: (state) =>
        ({
          selectedProduct: state.selectedProduct,
          productDetails: state.productDetails,
        }) as WfProductStore,
    }
  )
);
